import { Button } from '@trellis/roots/button'
import { Typography } from '@trellis/roots/typography'
import { Download, X } from 'lucide-react'
import { useState } from 'react'

import { usePwaInstallPrompt } from '@/hooks/usePwaInstallPrompt'

const DISMISSED_STORAGE_KEY = 'trellis-install-prompt-dismissed'

function isStandaloneDisplayMode(): boolean {
  return window.matchMedia('(display-mode: standalone)').matches
}

export function InstallPromptBanner() {
  const { isInstallable, promptInstall } = usePwaInstallPrompt()
  const [isDismissed, setIsDismissed] = useState(
    () => localStorage.getItem(DISMISSED_STORAGE_KEY) === 'true',
  )

  if (!isInstallable || isDismissed || isStandaloneDisplayMode()) return null

  function handleDismiss(): void {
    localStorage.setItem(DISMISSED_STORAGE_KEY, 'true')
    setIsDismissed(true)
  }

  return (
    <div
      role="region"
      aria-label="Install myTrellis"
      /* 4rem clears BottomNav's rendered height; keep in sync with AppShell.tsx's main
       * padding and ios-install-instructions.tsx's offset below. */
      className="bg-card fixed inset-x-4 bottom-[calc(4rem+1rem+env(safe-area-inset-bottom))] z-[45] flex items-center gap-3 rounded-xl border p-4 shadow-lg sm:inset-x-auto sm:right-4 sm:bottom-4 sm:w-96"
    >
      <Download className="text-primary size-5 shrink-0" aria-hidden="true" />
      <div className="min-w-0 flex-1">
        <Typography variant="body-sm" className="font-medium">
          Install myTrellis
        </Typography>
        <Typography variant="caption" color="muted">
          Add to your home screen for quick, app-like access.
        </Typography>
      </div>
      <Button size="sm" onClick={() => void promptInstall()}>
        Install
      </Button>
      <Button
        variant="ghost"
        size="icon"
        className="size-6 shrink-0"
        aria-label="Dismiss install prompt"
        onClick={handleDismiss}
      >
        <X className="size-3.5" />
      </Button>
    </div>
  )
}
